const selectors = {
  customerAddresses: '[data-customer-addresses]',
  addressCountrySelect: '[data-address-country-select]',
  addressContainer: '[data-address]',
  toggleAddressButton: 'button[aria-expanded]',
  cancelAddressButton: 'button[type="reset"]',
  deleteAddressButton: 'button[data-confirm-message]',
};

const attributes = {
  expanded: 'aria-expanded',
  confirmMessage: 'data-confirm-message',
};

class CustomerAddresses {
  constructor() {
    this.elements = this._getElements();
    if (Object.keys(this.elements).length === 0) return;
    this._setupCountries();
    this._setupEventListeners();
  }

  _getElements() {
    const container = document.querySelector(selectors.customerAddresses);
    return container
      ? {
        container,
        addressContainer: container.querySelector(selectors.addressContainer),
        toggleButtons: document.querySelectorAll(selectors.toggleAddressButton),
        cancelButtons: container.querySelectorAll(selectors.cancelAddressButton),
        deleteButtons: container.querySelectorAll(selectors.deleteAddressButton),
        countrySelects: container.querySelectorAll(selectors.addressCountrySelect),
      }
      : {};
  }

  _setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew',
      });
      this.elements.countrySelects.forEach((select) => {
        const formId = select.dataset.formId;
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
          hideElement: `AddressProvinceContainer_${formId}`,
        });
      });
    }
  }

  _setupEventListeners() {
    this.elements.toggleButtons.forEach((element) => {
      element.addEventListener('click', this._handleAddEditButtonClick);
    });
    this.elements.cancelButtons.forEach((element) => {
      element.addEventListener('click', this._handleCancelButtonClick);
    });
    this.elements.deleteButtons.forEach((element) => {
      element.addEventListener('click', this._handleDeleteButtonClick);
    });
  }

  _toggleExpanded(target) {
    target.setAttribute(attributes.expanded, (target.getAttribute(attributes.expanded) === 'false').toString());
  }

  _handleAddEditButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(currentTarget);
  };

  _handleCancelButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(currentTarget.closest(selectors.addressContainer).querySelector(`[${attributes.expanded}]`));
  };

  _handleDeleteButtonClick = ({ currentTarget }) => {
    // eslint-disable-next-line no-alert
    if (confirm(currentTarget.getAttribute(attributes.confirmMessage))) {
      Shopify.postLink(currentTarget.dataset.target, {
        parameters: { _method: 'delete' },
      });
    }
  };
}


document.addEventListener('DOMContentLoaded', () => {
  // Handle Edit button click
  document.querySelectorAll('[id^="EditFormButton_"]').forEach(button => {
    button.addEventListener('click', () => {
      const addressId = button.dataset.addressId;
      const form = document.getElementById(`EditAddress_${addressId}`);
      if (form) {
        form.classList.remove('hidden');
        button.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // Handle close button inside edit form
  document.querySelectorAll('.close-edit-form').forEach(closeBtn => {
    closeBtn.addEventListener('click', () => {
      const addressId = closeBtn.dataset.addressId;
      const form = document.getElementById(`EditAddress_${addressId}`);
      const button = document.getElementById(`EditFormButton_${addressId}`);
      if (form) {
        form.classList.add('hidden');
        button.setAttribute('aria-expanded', 'false');
      }
    });
  });
});

// ======================================= edit address open popup =============================//

function openForm(button) {
  const addressId = button.getAttribute('data-address-id');
  const popup = document.getElementById(`EditAddress_${addressId}`);
  const overlay = document.querySelector('.popup-overlay-account');

  if (popup && overlay) {
    popup.classList.add('active');
    overlay.classList.add('active');
    document.body.classList.add('no-scroll');
  }
}

function cancelForm(button) {
  const popup = button.closest('.user-edit-address-wrapper');
  const overlay = document.querySelector('.popup-overlay-account');

  if (popup && overlay) {
    popup.classList.remove('active');
    overlay.classList.remove('active');
    document.body.classList.remove('no-scroll');
  }
}

document.addEventListener('click', function (event) {
  const overlay = document.querySelector('.popup-overlay-account');
  if (event.target === overlay) {
    document
      .querySelectorAll('.user-edit-address-wrapper.active')
      .forEach((popup) => popup.classList.remove('active'));
    overlay.classList.remove('active');
    document.body.classList.remove('no-scroll');
  }
});

// ======================================= add address popup ========================//

// Open Add Address popup
function openAddAddressForm() {
  const popup = document.getElementById('AddAddress');
  const overlay = popup.querySelector('.popup-overlay-account');

  popup.classList.add('active');
  overlay.classList.add('active');
  document.body.classList.add('no-scroll');
}

// Close Add Address popup
function cancelAddAddressForm(button) {
  const popup = button.closest('.user-edit-address-wrapper');
  const overlay = popup.querySelector('.popup-overlay-account');

  popup.classList.remove('active');
  overlay.classList.remove('active');
  document.body.classList.remove('no-scroll');
}

// Close popup by clicking overlay
document.addEventListener('click', function (event) {
  if (event.target.classList.contains('popup-overlay-account')) {
    const popup = event.target.closest('.user-edit-address-wrapper');
    popup.classList.remove('active');
    event.target.classList.remove('active');
    document.body.classList.remove('no-scroll');
  }
});


// order history open accrdian open ===================== //

document.addEventListener('DOMContentLoaded', function () {
  // Open the first order by default
  var firstOrder = document.querySelector('.block_customers-order-info');
  if (firstOrder) {
    firstOrder.classList.add('open');
    firstOrder.querySelector('.block_customers-order-info-bottom').classList.add('active');
    firstOrder.querySelector('.block_order-mange-order').classList.add('active');
  }

  // Add click listener to the entire top-right block
  var toggleAreas = document.querySelectorAll('.block_customers-order-info-top-right');
  toggleAreas.forEach(function (area) {
    area.addEventListener('click', function () {
      var currentOrder = area.closest('.block_customers-order-info');
      
      // Close all other orders
      document.querySelectorAll('.block_customers-order-info').forEach(function (order) {
        if (order !== currentOrder) {
          order.classList.remove('open');
          order.querySelector('.block_customers-order-info-bottom').classList.remove('active');
          order.querySelector('.block_order-mange-order').classList.remove('active');
        }
      });

      // Toggle current order
      currentOrder.classList.toggle('open');
      currentOrder.querySelector('.block_customers-order-info-bottom').classList.toggle('active');
      currentOrder.querySelector('.block_order-mange-order').classList.toggle('active');
    });
  });
});
